import { render, staticRenderFns } from "./FAB.vue?vue&type=template&id=423aca69&scoped=true"
import script from "./FAB.vue?vue&type=script&lang=js"
export * from "./FAB.vue?vue&type=script&lang=js"
import style0 from "./FAB.vue?vue&type=style&index=0&id=423aca69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423aca69",
  null
  
)

export default component.exports